{
  "SEARCH": {
    "TABS": {
      "ALL": "Všetko",
      "CONTACTS": "Kontakty",
      "CONVERSATIONS": "Rozhovory",
      "MESSAGES": "Správy"
    },
    "SECTION": {
      "CONTACTS": "Kontakty",
      "CONVERSATIONS": "Rozhovory",
      "MESSAGES": "Správy"
    },
    "VIEW_MORE": "Zobraziť viac",
    "LOAD_MORE": "Načítať viac",
    "SEARCHING_DATA": "Vyhľadáva sa",
    "LOADING_DATA": "Načítava sa",
    "EMPTY_STATE": "Nenašli sa žiadne {item} pre dopyt '{query}'",
    "EMPTY_STATE_FULL": "Pre dopyt '{query}' sa nenašli žiadne výsledky",
    "PLACEHOLDER_KEYBINDING": "/ pre zameranie",
    "INPUT_PLACEHOLDER": "Napíšte 3 alebo viac znakov pre vyhľadávanie",
    "EMPTY_STATE_DEFAULT": "Hľadajte podľa ID konverzácie, e-mailu, telefónneho čísla, správ pre lepšie výsledky vyhľadávania. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Čítať viac",
    "WROTE": "napísal(a):",
    "FROM": "od",
    "EMAIL": "e-mail",
    "EMAIL_SUBJECT": "predmet",
    "RECENT_MESSAGES": "Moje nedávno odoslané správy"
  }
}
